"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const styled_1 = require("./styled");
/**
 * Section component <section> - usually used to wrap <ContentBlock />
 *
 */
const Section = (_a) => {
    var { children, background = "transparent" } = _a, rest = __rest(_a, ["children", "background"]);
    return (react_1.default.createElement(styled_1.Wrapper, Object.assign({ background: background }, rest), children));
};
Section.Backgrounds = bitcoincom_pkg_theme_1.colors.solid;
exports.default = Section;
//# sourceMappingURL=Section.js.map